/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-undef */
/* Start importing separated js files */
import {
    desktopTopMPU,
    mobileTopMPU1,
    midBannerInArticleMobile,
    toggleDisplayMobileMidMPUTopBanner,
} from "./components/adverts/_advertising-containers";
import {
    partnerContentSlider,
    relatedNewsSlider,
} from "./components/gallery/_glide-slider";
import {
    isMobile,
    isMediumViewport,
    updateLinksBehavior,
} from "./common/_constants";
import {
    jumpToLatestNewsHandler,
    previousWinnersHandler,
} from "./components/march_madness/_navigation-handlers";
import {
    lazyLoadTweetsHandler,
    removeServiceWorker,
} from "./components/helpers/_observer-handler";
import {
    leagueDropdownToggleHandler,
    leagueNewSelectedHandler,
} from "./components/metabet/_league";
import {
    liveBlogLongDateDifference,
    publishedLongDateDifference,
    updateListingPublishedFormats,
} from "./components/article/_published-date";
import {
    metabetRedirectionHandler,
    scheduleTeamLinkHandler,
    scoresTeamLinkHandler,
} from "./components/metabet/_redirection";
import { newRelatedArticlesHandler } from "./components/article/_related-news";
import { authorsAndPublishedDateHandler } from "./furniture/_author";
import { mobileStnFloatBehavour } from "./components/video_player/stn";
import { outbrainThumbnailsLazyloader } from "./components/adverts/_outbrain-lazyloader";
import { rebuildTables } from "./components/article/_tables";
import {
    setEditionItemsWidth,
    toggleEditionHandlerV2,
} from "./furniture/_edition";
import { setFooterSpacing } from "./furniture/_footer";
import { updateGridColumn } from "./components/metabet/_betting";
import { copyButtonLinkHandler } from "./components/article/_copy-button-link";
import { hideEmptyImageCredits } from "./components/article/_image-credit";

// Structure from previous js

removeServiceWorker();

const oneTrustModal = () => {
    const privacyTitles = [
        "Privacy Preference Center",
        "Preferencias de privacidad",
        "プライバシー設定",
        "개인 정보 보호 선호 센터",
        "Preferências de privacidade",
        "การตั้งค่าความเป็นส่วนตัว",
        "Tùy chọn quyền riêng tư",
        "Privacy Preferences",
        "Manage Preferences",
    ];
    const customPrivacyPreferenceSkin = ["skin-nesn.css", "skin-snp.css"];

    const setPrivacyPreference = (menuItems) => {
        if (!menuItems || menuItems.length < 1) return;

        menuItems.forEach((menuItem) => {
            let menuTextTrimmed = "";

            if (menuItem.querySelector("span")) {
                const mobileFooterMenu =
                    menuItem.querySelector("span:first-of-type").textContent;
                const desktopFooterMenu =
                    menuItem.querySelector("span:last-of-type").textContent;

                menuTextTrimmed = isMobile()
                    ? mobileFooterMenu.trim()
                    : desktopFooterMenu.trim();
            } else {
                menuTextTrimmed = menuItem.textContent.trim();
            }

            if (privacyTitles.includes(menuTextTrimmed)) {
                menuItem.setAttribute(
                    "data-privacy-preference-center",
                    "privacy-preference-center",
                );
                menuItem.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (window.OneTrust) {
                        window.OneTrust.ToggleInfoDisplay();
                    }
                });
            }
        });
    };

    const footerMainMenu = document.querySelectorAll("#new-footer-layout a");
    const sidebarFooterMenu = document.querySelectorAll(
        "#sidebarMenu #footerMenuOnMobileSidebar a",
    );
    const skin = document.body.dataset.skin;

    if (customPrivacyPreferenceSkin.includes(skin)) {
        const taglineDiv = document.querySelector(
            "[data-testid='footer-text-tagline']",
        );
        if (privacyTitles.includes(taglineDiv.textContent.trim())) {
            taglineDiv.setAttribute(
                "data-privacy-preference-center",
                "privacy-preference-center",
            );
        }
    } else {
        setPrivacyPreference(footerMainMenu);
        setPrivacyPreference(sidebarFooterMenu);
    }
};

const footerHandlers = () => {
    setFooterSpacing();
};

const mobileAndDesktopHandlers = () => {
    updateLinksBehavior();
    desktopTopMPU();
};

const newArticlePageHandlers = () => {
    const articlePage = document.querySelector(".article-page-new");
    const slideRelatedNewsEnabled = document.querySelector(
        "#article-related-article-block.slide-enabled",
    );

    if (articlePage) {
        // Place videoPlayerHandler after second paragraph of article
        const articleParagraphs = articlePage.querySelectorAll(
            "#article-body > div > p",
        );
        const articleParagraphCount = articleParagraphs.length;
        const videoContainer = document.querySelector(
            ".zephr-feature_video-player",
        );

        if (videoContainer && articleParagraphCount >= 2) {
            articleParagraphs[1].after(videoContainer);
        }

        if (isMobile()) {
            mobileTopMPU1();
        }

        if (slideRelatedNewsEnabled) {
            relatedNewsSlider();
        } else {
            newRelatedArticlesHandler("#article-body > div > p");
        }
        // Outbrain Lazyloader
        outbrainThumbnailsLazyloader();

        rebuildTables();

        // Lazy load twitter tweets
        lazyLoadTweetsHandler();
    }
};

const articleThreeColumnPageHandlers = () => {
    const articlePage = document.querySelector(
        ".article-page-new-three-column",
    );

    if (articlePage) {
        // Place videoPlayerHandler after second paragraph of article
        const articleParagraphs = articlePage.querySelectorAll(
            "#article-body > div > p",
        );
        const articleParagraphCount = articleParagraphs.length;
        const videoContainer = document.querySelector(
            ".zephr-feature_video-player",
        );
        const snpSkin = document.querySelector("[data-skin='skin-snp.css']");

        const shouldInsertVideo = !snpSkin || (snpSkin && isMobile());

        if (videoContainer && articleParagraphCount >= 2 && shouldInsertVideo) {
            articleParagraphs[1].after(videoContainer);
        }

        midBannerInArticleMobile();

        lazyLoadTweetsHandler();

        // Outbrain Lazyloader
        //outbrainThumbnailsLazyloader();

        rebuildTables();
    }
};

const articleTwoColumnPageHandlers = () => {
    const articlePage = document.querySelector(
        ".article-page-two-column-layout",
    );

    if (articlePage) {
        // Place videoPlayerHandler after second paragraph of article
        const articleParagraphs = articlePage.querySelectorAll(
            "#article-body > div > p",
        );
        const articleParagraphCount = articleParagraphs.length;
        const videoContainer = document.querySelector(
            ".zephr-feature_video-player",
        );

        if (
            videoContainer &&
            articleParagraphCount >= 2 &&
            isMediumViewport()
        ) {
            articleParagraphs[1].after(videoContainer);
        }

        midBannerInArticleMobile();

        lazyLoadTweetsHandler();

        rebuildTables();
    }
};

const metabetPageHandlers = () => {
    const metabetPage = document.querySelector(".metabet-page");
    const isBettingOdds = document.querySelector(
        "[data-page-type='betting-data-page-odds'] ",
    );
    if (metabetPage) {
        leagueDropdownToggleHandler();
        leagueNewSelectedHandler();
        metabetRedirectionHandler();
        scoresTeamLinkHandler();
        scheduleTeamLinkHandler();
    }

    if (isBettingOdds) {
        updateGridColumn();
    }
};

const pushAffiliateWidgetImpressions = () => {
    window.dataLayer = window.dataLayer || [];
    window.widgetImpressionEvents = window.widgetImpressionEvents || [];
    window.dataLayer.push(...window.widgetImpressionEvents);
};

const marchMadnessHandlers = () => {
    const isMarchMadnessPage = document.querySelector(".march-madness-page");

    if (isMarchMadnessPage) {
        previousWinnersHandler();
        jumpToLatestNewsHandler();
    }
};

const watchPageHandlers = () => {
    const isWatchPage = document.querySelector("[data-page-type='watch-page']");

    if (isWatchPage) {
        watchPagePartnersContentHandler();
    }
};

const displayDateTimeInArticleThumbnails = () => {
    const datetimeContainer = document.querySelector(
        "[data-testid='text--published-date']",
    );

    if (datetimeContainer) {
        updateListingPublishedFormats();
    }
};

const longDateHandler = () => {
    const publishedDateLong = document.querySelector(
        ".published-datetime-long",
    );
    if (publishedDateLong) {
        publishedLongDateDifference();
    }

    const liveBlogDateLong = document.querySelector(
        ".published-datetime-long-live-blog",
    );
    if (liveBlogDateLong) {
        liveBlogLongDateDifference();
    }
};

const watchPagePartnersContentHandler = () => {
    document.querySelector("[data-page-type='watch-page']") &&
        partnerContentSlider();
};

const stnPlayerHandlers = () => {
    mobileStnFloatBehavour();
};

const functionsToRun = [
    () => oneTrustModal(),

    () => mobileAndDesktopHandlers(),

    () => footerHandlers(),

    () => stnPlayerHandlers(),

    () => newArticlePageHandlers(),

    () => articleThreeColumnPageHandlers(),

    () => articleTwoColumnPageHandlers(),

    () => metabetPageHandlers(),

    () => marchMadnessHandlers(),

    () => watchPageHandlers(),

    () => displayDateTimeInArticleThumbnails(),

    () => longDateHandler(),

    () => authorsAndPublishedDateHandler(),

    () => toggleEditionHandlerV2(),

    () => copyButtonLinkHandler(),

    () => hideEmptyImageCredits(),

    () => toggleDisplayMobileMidMPUTopBanner(),
];

function initializeFunctions() {
    functionsToRun.forEach((func, index) => {
        try {
            func();
        } catch (error) {
            console.error(`Error in function at index ${index}:`, error);
        }
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeFunctions);
} else {
    initializeFunctions();
}

// BBCode widget tracking
window.addEventListener("load", () => {
    window.widgetImpressionEvents = window.widgetImpressionEvents || [];

    let widgetLinks = document.querySelectorAll("a[data-cta-id]");
    widgetLinks.forEach((widgetLink) => {
        // Impression tracking
        widgetImpressionEvents.push({
            event: "cta_impression",
            cta_type: widgetLink.getAttribute("data-cta-type"),
            cta_id: widgetLink.getAttribute("data-cta-id"),
        });
    });

    // Push impressions to dataLayer
    pushAffiliateWidgetImpressions();
});

window.addEventListener("resize", () => {
    setEditionItemsWidth();
    desktopTopMPU();
    watchPagePartnersContentHandler();
    toggleDisplayMobileMidMPUTopBanner();
});
